import { ColumnState } from '@ag-grid-community/core';

import { DatacenterFilterType } from './datacenter-filters';

export interface ColumnDefAndHeader {
	colId: string;
	header: string;
	pinned?: string | boolean | null | undefined;
	sortable?: boolean | undefined;
	groupId?: string | undefined;
}

export type NoNullField<T> = {
	[P in keyof T]: Exclude<T[P], null>;
};

export interface UserDatacenterView {
	id: number;
	name: string;
	version?: number;
	isDefault?: boolean;
	isFavorite?: boolean;
	type: DatacenterType;
	columnState: (NoNullField<ColumnState> & { colId: string; groupId?: string | undefined })[];
	subType?: string;
	sortModel?: ViewSortModel[] | null | undefined;
	filterState?: DatacenterFilterType[] | null | undefined;
	creationDate?: Date | string;
	modificationDate?: Date | string;
}
export interface ViewSortModel {
	colId: string;
	sort: 'asc' | 'desc';
}

export interface UserValueSelected {
	id: number;
	firstName: string;
	lastName: string;
}

export type AdditionalInput = Record<string, string>;

export const ECALL_BY_BATCH_DATACENTER_TYPE = 'calloff-by-batch';
export const ECALL_BY_VOLUME_DATACENTER_TYPE = 'calloff-by-volume';
export const ECALL_DATACENTER_TYPE = 'calloff';

export type DatacenterType =
	'offer'
	| 'order'
	| 'batch'
	| 'shipment'
	| 'quality'
	| 'document'
	| 'schedule-business-order'
	| 'guarantee'
	| 'organization'
	| 'users'
	| 'aqdb'
	| 'product-list'
	| 'prototypes'
	| typeof ECALL_BY_VOLUME_DATACENTER_TYPE
	| typeof ECALL_BY_BATCH_DATACENTER_TYPE
	| typeof ECALL_DATACENTER_TYPE;
